<template>
  <div class="xkxslb">
    <Header title="选课学生列表" type="0" route="/xkmdck/jxapgl"></Header>
    <van-search
      v-model="xsxx"
      shape="round"
      placeholder="请输入学生信息（学号或姓名）…"
      @input="getList"
    />
    <div class="xkxslb_main">
      <div class="xkxslb_main_header">
        <h3>{{ info.kcmc ? info.kcmc : "-" }}</h3>
        <ul>
          <li>
            <span>学生人数：</span>
            <p>{{ info.xkrs ? info.xkrs : "-" }}</p>
          </li>
          <li>
            <span>开课单位：{{ info.kkdw ? info.kkdw : "-" }}</span>
          </li>
        </ul>
      </div>
      <NOdata title="暂无选课学生列表数据~" v-if="list.length == 0"></NOdata>
      <mode-list1
        v-else
        v-for="(item, index) in list"
        :key="index"
        :item="item"
      ></mode-list1>
    </div>
    <div class="back_top" @click="backTop">
      <van-icon name="back-top" />
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import modeList1 from "./mode/modeList1.vue";
export default {
  components: { modeList1 },
  data() {
    return {
      info: {},
      xsxx: "",
      list: []
    };
  },
  created() {
    Object.assign(this.info, this.$route.query.item);
    this.getList();
  },
  methods: {
    backTop() {
      $(".xkxslb_main")[0].scrollTop = 0;
    },
    async getList() {
      const res = await Api.findXkxsList({
        jx0404id: this.info.jx0404id,
        xsxx: this.xsxx
      });
      if (res.code == 1) {
        this.list = res.data;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.xkxslb {
  height: 100%;
  background-color: #f2f2f4;
  box-sizing: border-box;
  .xkxslb_main {
    box-sizing: border-box;
    height: calc(~"100% - 54px");
    padding: 10px 15px 0;
    overflow: auto;
    .xkxslb_main_header {
      position: relative;
      border-radius: 8px;
      background-image: linear-gradient(#8c82ff 0%, #7368ff 100%);
      padding: 15px;
      margin-bottom: 10px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/images/xkxslb_main_header.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
      }
      h3 {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 4px;
        line-height: 22px;
      }
      ul {
        li {
          display: flex;
          align-items: center;
          margin-bottom: 2px;
          span {
            line-height: 20px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0;
            line-height: 25px;
            font-weight: lighter;
          }
          p {
            line-height: 25px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #ffffff;
            letter-spacing: 0;
            line-height: 25px;
          }
        }
      }
    }
  }
  .back_top {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 8px;
    bottom: 20%;
    width: 40px;
    height: 40px;
    background: #7469f8;
    background-color: #7469f8;
    border-radius: 50%;
    .van-icon {
      color: #fff;
      font-weight: bolder;
      font-size: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xkmdck/xkxslb.vue